import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'

import { updateLastActivityAt } from '_modules/user/actions'
import { createNonTask, getNonTasks } from '_modules/non-task/actions'
import Icon from '_components/icon'
import Slider from '_components/slider'
import FormElement from '_components/formElement'
import FormBody from '_components/formBody'

import CategoryTabBodySwipe from '../categoryTabBodySwipe'
import Answer from './answer'
import styles from './styles.css'

const mapStateToProps = ({}) => ({})

const mapDispatchToProps = {
  createNonTask,
  updateLastActivityAt,
  getNonTasks,
}

class ThoughtsForm extends PureComponent {
  static propTypes = {
    closePlusForm: PropTypes.func.isRequired,
    createNonTask: PropTypes.func.isRequired,
    updateLastActivityAt: PropTypes.func.isRequired,
    getNonTasks: PropTypes.func.isRequired,
  }

  state = {
    thoughtName: '',
    reflection: '',
    rank: 5,
  }

  componentDidMount() {
    if (this.inputRef) this.inputRef.focus()
    document.addEventListener('keydown', this.onKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown = event => {
    if (event.key === 'Enter') {
      this.onSave()
    }
  }

  onChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  onSave = () => {
    const { thoughtName: label, rank, reflection } = this.state

    if (!label || !rank || !reflection) {
      this.props.displayError('Missing Fields')
      return
    }

    const payload = {
      type: 2,
      label,
      rank,
      reflection,
    }

    this.props.createNonTask(payload)
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
    this.resetPlusForm()
    this.props.closePlusForm()
  }

  onCancel = () => {
    this.props.closePlusForm()
  }

  resetPlusForm = () => {
    this.props.getNonTasks()
    this.setState({
      thoughtName: '',
      reflection: '',
      rank: 1,
    })
  }

  render() {
    const { thoughtName, rank, reflection } = this.state

    const buttons = [
      { label: 'Save', onClick: this.onSave },
      { label: 'Cancel', onClick: this.onCancel },
    ]

    return (
      <CategoryTabBodySwipe question="Learn more here!" answer={<Answer />}>
        <FormBody buttons={buttons}>
          <FormElement label="Thought">
            <input
              ref={input => (this.inputRef = input)}
              type="text"
              id="thoughtName"
              value={thoughtName}
              className={classnames(styles['form-input'])}
              onChange={this.onChange}
              autoComplete="off"
            />
          </FormElement>
          <FormElement label="Rank">
            <Slider
              min={1}
              max={10}
              value={rank}
              onChange={rank => this.setState({ rank })}
              color="#9AD98E"
            />
          </FormElement>
          <FormElement label="Reflection" labelStyle={{ alignSelf: 'flex-start' }}>
            <textarea
              id="reflection"
              rows="6"
              value={reflection}
              className={classnames(styles['form-textarea'])}
              onChange={this.onChange}
            />
          </FormElement>
        </FormBody>
      </CategoryTabBodySwipe>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThoughtsForm)



// WEBPACK FOOTER //
// ./src/components/categoryTabs/thoughtsForm/index.js